import React, { Children } from "react";
export var checkChildren = function (childNodes) {
    var result = null;
    // Use forEach to iterate and allow early return
    Children.forEach(childNodes, function (child) {
        if (!React.isValidElement(child))
            return; // Skip non-elements
        // Get the displayName or fallback to name
        // @ts-ignore
        var displayName = child.type.displayName || child.type.name || '';
        // Stop and return false if Section is found
        if (displayName === 'Section') {
            result = false;
            return false; // Break the loop
        }
        // Stop and return true if Input is found
        if (displayName === 'Input') {
            result = true;
            return false; // Break the loop
        }
        // Recursively check children of VStack or HStack
        if (displayName === 'VStack' || displayName === 'HStack') {
            // @ts-ignore
            var nestedResult = checkChildren(child.props.children);
            if (nestedResult !== null) {
                result = nestedResult; // Propagate the result up
                return false; // Break the loop
            }
        }
    });
    return result; // Return null if no conditions matched
};
